import { to } from 'to'
import { BACKEND_URL } from './constants'

export const Locations = {
    Article: (slug = ':slug') => to('blog', `/${slug}`),
    Blog: () => to('blog'),
    Calculator: () => to('calculator'), // d2c only
    Calculate: (type = ':type') => to('calculate/:type').replace(':type', type),
    OnboardingCalculateEntry: () => to('onboarding-calculate-entry'),
    QuarterlyCalculateEntry: () => to('quarterly-calculate-entry'),
    MigrationCalculateEntry: () => to('migration-calculate-entry'),
    CalculateSubmission: (type = ':type') => to('calculate-submission/:type').replace(':type', type),
    ReCalculateD2c: () => to('re-calculate-d2c'), // d2c only
    ReCalculateEntry: () => to('re-calculate-entry'), // d2c only
    CancelMembership: () => to('cancel-membership'),
    Checkout: () => to('checkout'), // d2c only
    Contact: () => to('contact'),
    Dashboard: () => to('dashboard'),
    AccountSettings: () => to('account-settings'),
    Faq: () => to('faq'),
    ForgotPassword: () => to('forgot-password'),
    Home: () => to(''),
    Login: () => to('login'),
    Logout: () => to('logout'),
    Membership: () => to('membership'), // d2c only
    Plan: () => to('plan'), // d2c only
    UpdatePlan: () => to('update-plan'), // d2c only
    ClimateClass: (moduleHandle = '', hash = '') =>
        to('climate-class', moduleHandle ? `?module=${moduleHandle}${hash}` : ''),
    ClimateClassView: (contentId = ':contentId', seoString = ':seoString') =>
        to('climate-class-view/:contentId/:seoString?')
            .replace(':contentId', contentId)
            .replace(':seoString?', seoString),
    ClimateJourney: () => to('climate-journey'),
    SharedClimateJourney: (token = ':token') => to('share-climate-journey/:token').replace(':token', token),
    Careers: () => to('company'),
    ReserveDemo: () => to('reserve-demo'),
    OrgSignup: (token = ':token') => to('admin-signup/:token').replace(':token', token),
    OrgEditCompany: () => to('admin-edit-company'),
    OrgDashboard: () => to('admin-dashboard'),
    OrgTeamManagement: () => to('admin-team'),
    OrgPayments: () => to('admin-payments'),
    OrgContentOverview: () => to('admin-content-overview'),
    OrgEditGroupModules: () => to('admin-content-overview-group-modules'),
    OrgEditPersonalizedModules: () => to('admin-content-overview-personalized-modules'),
    OrgContentView: (moduleId = ':moduleId') => to('admin-content-view/:moduleId').replace(':moduleId', moduleId),
    ChooseGroupModules: () => to('choose-group-modules'),
    ChoosePersonalizedModules: () => to('choose-personalized-modules'),
    ReviewSelectedModules: () => to('review-selected-modules'),
    ConnectChatApp: () => to('connect-chat-app'),
    TeamsInstructions: () => to('teams-instructions'),
    Projects: () => to('projects'),
    Receipts: () => to('receipts'),
    SingleProject: (slug = ':slug') => to('project/:slug').replace(':slug', slug),
    Privacy: () => to('privacy'),
    CookiesPolicy: () => to('cookies-policy'),
    ResetPassword: () => to('reset-password'),
    Rewards: () => to('rewards'),
    ShopifyPrivacy: () => to('brand-app-privacy'),
    Terms: () => to('terms'),
    SecurityCommitment: () => to('security-commitment'),
    EmployeeInviteLink: (token = ':token') => to('employee-invite/:token').replace(':token', token),
    Pdf: (url = ':url') => to('pdf/:url').replace(':url', url),
    Receipt: (id = ':id') => to('receipt/:id').replace(':id', id),
    AuthSocialCallback: () => to('auth/social'),
    OrgSustainabilitySurvey: () => to('employee-climate-survey'),
    SlackConnect: () => `${BACKEND_URL}/slack/connect`,
    PointsOverview: () => to('points-overview'),
    HowToEarnPoints: () => to('how-to-earn-points'),
    PointHistory: () => to('point-history'),
    PointRedemptions: () => to('point-redemptions'),
    TeamsConnect: () => `${BACKEND_URL}/teams/connect`,
    Challenges: () => to('challenges'),
    Challenge: (id = ':id') => to('challenge/:id').replace(':id', id),
    AdminChallenges: () => to('admin-challenges'),
    AdminChallenge: (id = ':id') => to('admin-challenge/:id').replace(':id', id),
    Product: () => to('product'),
    CustomerStories: () => to('customer-stories'),
    CustomerStory: (url = ':url') => to('customer-stories', `/${url}`),
    SendChatAppMessage: () => to('send-chat-app-message'),
    SlackLandingPage: () => to('slack-landing-page')
}
